import React, { Dispatch, SetStateAction } from 'react';
import cn from 'classnames';

import { SelectOptionProps } from '@components/common/Select/Select';

import { Icons } from '@icons/icons';

interface IGroupHeadingProps {
	props: SelectOptionProps;
	collapsedGroups: string[];
	setCollapsedGroups: Dispatch<SetStateAction<string[]>>;
	allGroupLabels: string[];
	singleOpenGroup: boolean;
}

const GroupHeading = ({
	props,
	collapsedGroups,
	setCollapsedGroups,
	allGroupLabels,
	singleOpenGroup,
}: IGroupHeadingProps) => {
	const { data } = props;
	const label = data.label?.toString() || '';
	const isCollapsed = collapsedGroups.includes(label);
	const collapsedGroupIcon = isCollapsed
		? Icons.chevronDown()
		: Icons.chevronUp();
	const groupHeadingClassName = cn('f5gSelectGroupHeading', {
		'f5gSelectGroupHeadingSeparatorTop': data.groupIndex !== 0,
	});

	const toggleGroupCollapsedState = () => {
		setCollapsedGroups((prevState) => {
			const currentlyCollapsed = prevState.includes(label);

			if (!singleOpenGroup) {
				return currentlyCollapsed
					? prevState.filter((group) => group !== label)
					: [...prevState, label];
			}

			if (currentlyCollapsed) {
				return allGroupLabels.filter((group) => group !== label);
			}

			return Array.from(new Set([...prevState, label]));
		});
	};

	return (
		<div
			className={groupHeadingClassName}
			onClick={toggleGroupCollapsedState}
		>
			{label} {collapsedGroupIcon}
		</div>
	);
};

export default GroupHeading;
